import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { NotificationService } from 'src/app/services/notification.service';
import {IdnowBackendsService} from 'src/app/services/idnow-backend-services'
import {UtilService} from "../../helpers/util.service";

@Component({
  selector: 'idnow-front-id',
  templateUrl: './front-id.component.html',
  styleUrls: ['./front-id.component.css']
})
export class FrontIDComponent implements OnInit {
  activateButton : boolean;
    deviceChecked = {
        isDesktop: false,
        isMobile: false,
        isTablet: false,
        so: ''
    };

  constructor(private activatedRoute: ActivatedRoute,
    private idnowBackendsService: IdnowBackendsService, private router: Router,
    private notifyService : NotificationService, private utilService: UtilService) {
      this.deviceChecked =  this.utilService.checkDevice();
      console.log(' this.deviceChecked',  this.deviceChecked);
  }

  ngOnInit() {

     //Metodo original, descomentar cuando la pagina previa esté lista
      this.activatedRoute.queryParams.subscribe(params => {
      try{
        this.activateButton = false;

        this.idnowBackendsService.queryOOBEnrollment(localStorage.getItem("uuidTransaction").replace("\"","").replace("\"",""),
          () => this.activateButton = true,
          () => this.activateButton = false
        );
      }catch(error){
        console.error('Error en componente: ', error);
        this.notifyService.showError("Lo lamentamos, no pudimos llevar a cabo su enrolamiento", "Error")
      }
    });

   /*
   try{
    this.activateButton = false;
    
    this.idnowBackendsService.initOOBEnrollment('25.235.818-8', uuidv4(), data => {
      this.idnowBackendsService.queryOOBEnrollment(data.uuidTransaction, 
        () => this.activateButton = true,
        () => this.activateButton = false
      );
    })
  }catch(error){
    console.error('Error en componente: ', error);
    this.notifyService.showError("Lo lamentamos, no pudimos llevar a cabo su enrolamiento", "Error")
  }
  */
  }
}
